// gorgias-chat-toggle.js
(function () {
  // Utility: wait for Gorgias to initialize
  function waitForGorgias() {
    return new Promise(function (resolve) {
      if (window.GorgiasChat) {
        resolve();
      } else {
        window.addEventListener('gorgias-widget-loaded', function () {
          resolve();
        });
      }
    });
  }

  // Main init logic
  waitForGorgias().then(function () {
    try {
      // Hide the default Gorgias button safely
      if (typeof GorgiasChat.hide === 'function') {
        GorgiasChat.hide();
      }

      // Helper: toggle open/close
      function toggleChat() {
        if (typeof GorgiasChat.isOpen === 'function' && GorgiasChat.isOpen()) {
          GorgiasChat.close();
        } else {
          GorgiasChat.open();
        }
      }

      // Close when clicking outside the chat window
      function setupOutsideClickClose() {
        document.addEventListener('click', function (e) {
          // Adjust selector if your chat container has a different ID
          const chatWindow = document.querySelector('#chat-window');

          // If chat is open, the click target exists, and it's outside the chat window
          if (
            typeof GorgiasChat.isOpen === 'function' &&
            GorgiasChat.isOpen() &&
            chatWindow &&
            !chatWindow.contains(e.target) &&
            !e.target.closest('.js--chat')
          ) {
            GorgiasChat.close();
          }
        });
      }

      // Attach click listeners to all .js--chat elements
      function bindChatTriggers() {
        const chatTriggers = document.querySelectorAll('.js--chat');
        chatTriggers.forEach(function (el) {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            toggleChat();
          });
        });
        console.log('Gorgias Chat toggle initialized on', chatTriggers.length, 'elements.');
      }

      bindChatTriggers();
      setupOutsideClickClose();
    } catch (err) {
      console.error('Error initializing Gorgias Chat toggle:', err);
    }
  });
})();
